/* Emoto Vlašim — rozkresy výrobce (25. 9. 2026). Stránka sestavy: čísla na výkresu ↔ karty v mřížce,
   bublina s cenou a košíkem (počítač) / spodní list (telefon), díly z výkresu první + čára před ostatními,
   hluboký odkaz #rz-N z karty dílu. Víc výkresů v sestavě = pohledy (přepínač, čísla navazují).
   Telefon: vlastní rozložení značek (tx/ty), široký výkres roluje do šířky, „Zvětšit“ = výkres 2× širší
   než obrazovka přes celou obrazovku. Karta dílu: odkaz podle vybrané motorky.
   Košík: tlačítko nese data-emoto-koupit → obsluhuje ho emoto-v3.js (stejná událost jako Horizon). */

const KLIC = 'emoto_motorka';
const moje = () => { try { return localStorage.getItem(KLIC) || ''; } catch (e) { return ''; } };
const motion = () => (matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth');
const esc = (s) => String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

/* ---------- karta dílu: odkaz na rozkres podle vybrané motorky ---------- */
document.querySelectorAll('[data-emoto-rz-odkaz]').forEach((a) => {
  const m = moje();
  const modely = (a.getAttribute('data-modely') || '').split(' ').filter(Boolean);
  if (m && modely.includes(m)) a.href = a.href.replace(/\/model-[a-z0-9-]+#/, `/model-${m}#`);
});

/* ---------- stránka motorky: „Nebo procházej všechny díly“ odkryje výpis s filtry ---------- */
document.querySelectorAll('[data-emoto-vse]').forEach((b) => b.addEventListener('click', () => {
  document.body.classList.add('e-ukaz-vse');
  const cil = document.querySelector('results-list.product-grid-container');
  if (cil) setTimeout(() => cil.scrollIntoView({ behavior: motion(), block: 'start' }), 50);
}));

/* ---------- stránka sestavy ---------- */
const panel = document.querySelector('[data-emoto-rozkres]');
if (panel) {
  const sheet = document.querySelector('[data-emoto-rz-sheet]');
  const telefon = matchMedia('(max-width: 749px)');
  const useSheet = () => matchMedia('(hover: none)').matches || telefon.matches;
  const views = [...panel.querySelectorAll('[data-emoto-rz-view]')].map((el) => ({
    el, id: el.dataset.emotoRzView, pomer: +el.dataset.pomer || 0.625, tw: +el.dataset.tw || 358,
    scroll: el.querySelector('.e-rz__scroll'), stage: el.querySelector('.e-rz__stage'),
    svg: el.querySelector('.e-rz__lines'), tip: el.querySelector('.e-rz__tip'),
    marks: [...el.querySelectorAll('.e-rz__mk')],
  }));
  const marks = views.flatMap((v) => v.marks);
  let aktivni = views[0];
  let pin = null;
  let hideT = null;
  let zoom = null;

  // rozložení značek: počítač / zvětšení = mx,my · telefon = tx,ty (spočítané pro šířku tw)
  function rozloz(v = aktivni) {
    const tel = telefon.matches && !zoom;
    v.marks.forEach((mk) => {
      mk.style.left = `${tel ? mk.dataset.tx : mk.dataset.mx}%`;
      mk.style.top = `${tel ? mk.dataset.ty : mk.dataset.my}%`;
    });
    if (zoom) v.stage.style.width = `${Math.max(innerWidth * 2, 760)}px`;
    else if (tel) v.stage.style.width = `${Math.max(v.scroll.clientWidth, v.tw > 358 ? v.tw : 0)}px`;   // běžný výkres = šířka panelu, široký (sedlo) roluje
    else v.stage.style.width = `${Math.min(v.scroll.clientWidth, 1100, Math.round(680 / v.pomer))}px`;   // počítač: vysoký výkres max ~680 px
    v.svg.innerHTML = v.marks.map((mk) => {
      const x = +mk.dataset.x, y = +mk.dataset.y, mx = parseFloat(mk.style.left), my = parseFloat(mk.style.top);
      if (Math.hypot(mx - x, (my - y) * v.pomer) < 0.8) return '';
      return `<line x1="${mx}" y1="${my * v.pomer}" x2="${x}" y2="${y * v.pomer}"/><circle cx="${x}" cy="${y * v.pomer}" r=".32"/>`;
    }).join('');
  }
  views.forEach((v) => rozloz(v));
  telefon.addEventListener('change', () => views.forEach((v) => rozloz(v)));

  // pohledy (víc výkresů pro jednu motorku)
  function prepni(id) {
    const v = views.find((x) => x.id === id);
    if (!v || v === aktivni) return;
    pin = null; off();
    views.forEach((x) => { x.el.hidden = x !== v; });
    panel.querySelectorAll('[data-emoto-rz-tab]').forEach((t) => t.setAttribute('aria-selected', String(t.dataset.emotoRzTab === id)));
    aktivni = v;
    rozloz(v);
  }
  panel.querySelectorAll('[data-emoto-rz-tab]').forEach((t) => t.addEventListener('click', () => prepni(t.dataset.emotoRzTab)));

  const cards = (n) => [...document.querySelectorAll(`.product-grid__item[data-emoto-n="${n}"]`)];
  const card = (n) => cards(n)[0] || null;
  const cardByHandle = (h) => document.querySelector(`.product-grid__item[data-emoto-handle="${h}"]`);
  const mark = (n) => marks.find((m) => +m.dataset.n === n);
  const viewOf = (n) => views.find((v) => v.marks.some((m) => +m.dataset.n === n));

  // jedno číslo může být víc dílů (šroub M6×10 a M6×12 mají u Starku týž obrázek) → seznam
  function info(n) {
    const mk = mark(n);
    const dily = (mk.dataset.dily || `${mk.dataset.handle}|${mk.dataset.kod};`).split(';').filter(Boolean).map((s) => s.split('|'));
    const vse = dily.map(([handle, kod]) => {
      const li = cardByHandle(handle);
      const out = { n, kod, url: `/products/${handle}`, nazev: '', cena: '', stav: null, koupit: null, foto: '', pozadi: 'foto' };
      if (li) {
        out.nazev = li.querySelector('.product-card__link')?.getAttribute('aria-label')?.trim() || '';
        out.cena = (li.querySelector('product-price, .price')?.innerText.match(/\d[\d\s ]*Kč/) || [''])[0].replace(/\s+/g, ' ');
        out.stav = li.querySelector('.e-stav')?.cloneNode(true) || null;
        out.koupit = li.querySelector('[data-emoto-koupit]')?.cloneNode(true) || null;
        out.foto = li.querySelector('.card-gallery img')?.currentSrc || '';
        out.pozadi = li.querySelector('[data-emoto-pozadi]')?.getAttribute('data-emoto-pozadi') || 'foto';
      }
      return out;
    });
    // díl bez karty v tomhle výpisu (na vybranou motorku nesedí) se v seznamu neukazuje; bez jediné karty zůstane kód
    const sKartou = vse.filter((i) => i.nazev);
    return sKartou.length ? sKartou : vse.slice(0, 1);
  }

  function naplnit(el, seznam, patka) {
    el.innerHTML = '';
    seznam.forEach((i, idx) => {
      const blok = document.createElement('div');
      blok.className = 'e-rz__dil';
      blok.innerHTML = (idx === 0 ? `<div class="e-rz__tip-top"><span class="e-rz-n e-rz-n--s">${i.n}</span><div class="e-kod"><b>Stark Varg</b><span>${esc(i.kod)}</span></div></div>`
        : `<div class="e-rz__tip-top e-rz__tip-top--dalsi"><div class="e-kod"><b>Stark Varg</b><span>${esc(i.kod)}</span></div></div>`)
        + (i.nazev ? `<p class="e-rz__tip-t">${esc(i.nazev)}</p>` : '')
        + `<div class="e-rz__tip-f"><b class="e-rz__tip-p">${esc(i.cena)}</b></div>`;
      const f = blok.querySelector('.e-rz__tip-f');
      if (i.stav) f.parentNode.insertBefore(i.stav, f);
      if (i.koupit) f.appendChild(i.koupit);
      el.appendChild(blok);
    });
    el.insertAdjacentHTML('beforeend', patka(seznam[0]));
  }

  function on(n, sTipem) {
    const v = viewOf(n);
    if (v && v !== aktivni) prepni(v.id);
    panel.querySelectorAll('.e-rz__ov').forEach((o) => o.classList.toggle('is-on', +o.dataset.n === n));
    marks.forEach((m) => m.classList.toggle('is-on', +m.dataset.n === n));
    document.querySelectorAll('.product-grid__item[data-emoto-n]').forEach((li) => li.classList.toggle('is-on', +li.dataset.emotoN === n));
    const tip = aktivni.tip;
    if (!sTipem) { tip.hidden = true; return; }
    const seznam = info(n);
    naplnit(tip, seznam, (i) => (seznam.length > 1 ? '' : `<a class="e-rz__tip-a" href="${i.url}">Karta dílu</a>`));
    tip.hidden = false;
    const mk = mark(n);
    const W = aktivni.stage.clientWidth, H = aktivni.stage.clientHeight;
    const px = (parseFloat(mk.style.left) / 100) * W, py = (parseFloat(mk.style.top) / 100) * H;
    const tw_ = tip.offsetWidth, th = tip.offsetHeight;
    let left = px + 24;
    if (left + tw_ > W - 8) left = px - 24 - tw_;
    tip.style.left = `${Math.max(8, left)}px`;
    tip.style.top = `${Math.max(8, Math.min(H - th - 8, py - th / 2))}px`;
  }
  function off() {
    panel.querySelectorAll('.e-rz__ov.is-on, .e-rz__mk.is-on').forEach((e) => e.classList.remove('is-on'));
    document.querySelectorAll('.product-grid__item.is-on').forEach((e) => e.classList.remove('is-on'));
    views.forEach((v) => { v.tip.hidden = true; });
  }
  const pozdejiOff = () => { clearTimeout(hideT); hideT = setTimeout(() => { if (pin == null) off(); }, 180); };

  // telefon: info dílu s košíkem — pod výkresem (inline); ve zvětšení jako lišta dole v překryvu
  const infoBox = panel.querySelector('[data-emoto-rz-info]');
  function otevriList(n) {
    const seznam = info(n);
    const i = seznam[0];
    const el = zoom ? sheet : infoBox;
    el.innerHTML = `<div class="e-rz__sheet-img" data-pozadi="${esc(i.pozadi)}">${i.foto ? `<img src="${i.foto}" alt="">` : ''}</div><div class="e-rz__sheet-b"></div><button type="button" class="e-rz__sheet-x" aria-label="Zavřít">×</button>`;
    naplnit(el.querySelector('.e-rz__sheet-b'), seznam, () => `<button type="button" class="e-rz__sheet-card">Ukázat kartu v seznamu</button>`);
    el.hidden = false;
    if (zoom) zoom.appendChild(sheet); else { sheet.hidden = true; el.scrollIntoView({ behavior: motion(), block: 'nearest' }); }
    el.querySelector('.e-rz__sheet-x').onclick = () => { el.hidden = true; off(); };
    el.querySelector('.e-rz__sheet-card').onclick = () => {
      el.hidden = true;
      if (zoom) zavriZoom();
      const li = card(n);
      if (li) li.scrollIntoView({ behavior: motion(), block: 'center' });
    };
  }
  const zavriInfo = () => { if (infoBox) infoBox.hidden = true; if (sheet) sheet.hidden = true; };

  // zvětšení přes celou obrazovku (telefon): aktivní výkres se přesune do překryvu a zpět
  function otevriZoom() {
    if (zoom) return;
    const v = aktivni;
    zoom = document.createElement('div');
    zoom.className = 'e-rz__zoom';
    zoom.innerHTML = `<div class="e-rz__zoom-bar"><span>${esc(panel.querySelector('.e-rz__h')?.textContent || 'Rozkres')}</span><button type="button" class="e-rz__zoom-x" aria-label="Zavřít">×</button></div>`;
    zoom.appendChild(v.stage);
    document.body.appendChild(zoom);
    document.body.style.overflow = 'hidden';
    zoom.querySelector('.e-rz__zoom-x').onclick = zavriZoom;
    pin = null; off(); rozloz(v);
    zoom.scrollLeft = (v.stage.offsetWidth - innerWidth) / 2;
  }
  function zavriZoom() {
    if (!zoom) return;
    const v = views.find((x) => zoom.contains(x.stage)) || aktivni;
    v.scroll.appendChild(v.stage);
    document.body.appendChild(sheet); sheet.hidden = true;
    zoom.remove();
    zoom = null;
    document.body.style.overflow = '';
    pin = null; off(); rozloz(v);
  }
  panel.querySelector('[data-emoto-rz-zoom]')?.addEventListener('click', otevriZoom);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { if (zoom) zavriZoom(); else { zavriInfo(); off(); } } });

  function ukaz(n) {
    const v = viewOf(n);
    if (v && v !== aktivni) prepni(v.id);
    aktivni.stage.scrollIntoView({ behavior: motion(), block: 'center' });
    setTimeout(() => {
      if (useSheet()) { on(n, false); otevriList(n); } else { pin = n; on(n, true); }
    }, motion() === 'smooth' ? 380 : 0);
  }

  marks.forEach((mk) => {
    const n = +mk.dataset.n;
    mk.addEventListener('mouseenter', () => { if (!useSheet() && pin == null) { clearTimeout(hideT); on(n, true); } });
    mk.addEventListener('mouseleave', () => { if (!useSheet() && pin == null) pozdejiOff(); });
    mk.addEventListener('click', (e) => {
      e.stopPropagation();
      if (useSheet()) { on(n, false); otevriList(n); return; }
      if (pin === n) { pin = null; off(); } else { pin = n; on(n, true); }
    });
  });
  views.forEach((v) => {
    v.tip.addEventListener('mouseenter', () => clearTimeout(hideT));
    v.tip.addEventListener('mouseleave', () => { if (pin == null) pozdejiOff(); });
  });
  document.addEventListener('click', (e) => {
    if (pin != null && !e.target.closest('.e-rz__tip, .e-rz-n')) { pin = null; off(); }
  });
  addEventListener('resize', () => { pin = null; off(); views.forEach((v) => rozloz(v)); });

  // karty: najetí zvýrazní díl na výkresu, číslo v rohu ho ukáže
  document.addEventListener('mouseover', (e) => {
    const li = e.target.closest('.product-grid__item[data-emoto-n]');
    if (!li || useSheet() || pin != null) return;
    clearTimeout(hideT);
    on(+li.dataset.emotoN, false);
  });
  document.addEventListener('mouseout', (e) => {
    const li = e.target.closest('.product-grid__item[data-emoto-n]');
    if (li && !li.contains(e.relatedTarget) && !useSheet() && pin == null) pozdejiOff();
  });
  document.addEventListener('click', (e) => {
    const b = e.target.closest('.product-grid__item > .e-rz-n');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    ukaz(+b.parentNode.dataset.emotoN);
  });

  // čára „Další díly sestavy“ mezi očíslovanými a ostatními kartami (Horizon mřížku překresluje → hlídat)
  function cara() {
    const grid = document.querySelector('.product-grid');
    if (!grid || grid.querySelector('.e-rz-div')) return;
    const s = grid.querySelectorAll('.product-grid__item[data-emoto-n]').length;
    const bez = grid.querySelectorAll('.product-grid__item:not([data-emoto-n])').length;
    if (!s || !bez) return;
    const li = document.createElement('li');
    li.className = 'e-rz-div';
    li.style.order = '899';
    li.textContent = 'Další díly sestavy · na výkresu nejsou';
    grid.appendChild(li);
  }
  cara();
  new MutationObserver(cara).observe(document.body, { childList: true, subtree: true });

  // hluboký odkaz z karty dílu: /collections/sestava-x/model-ex#rz-3
  const m = location.hash.match(/^#rz-(\d+)$/);
  if (m && mark(+m[1])) setTimeout(() => ukaz(+m[1]), 250);
}
